import React from 'react';
import { CustomHeader } from 'react-calendar-timeline';

interface TimelineYearHeaderProps {
  onYearClick: () => void;
}

const TimelineYearHeader: React.FC<TimelineYearHeaderProps> = ({
  onYearClick,
}) => {
  return (
    // @ts-ignore
    <CustomHeader unit="year">
      {(props: any) => {
        const {
          headerContext: { intervals },
          getRootProps,
          getIntervalProps,
          showPeriod,
        } = props;
        return (
          <div {...getRootProps()}>
            {intervals.map((interval: any) => {
              const intervalStyle: React.CSSProperties = {
                lineHeight: '30px',
                textAlign: 'center',
                cursor: 'pointer',
                fontFamily: '"Roboto Condensed",Helvetica,Arial,"sans-serif"',
                fontSize: '15px',
                fontWeight: 'bold',
              };
              const intervalProps: any = getIntervalProps({
                interval,
                style: intervalStyle,
              });
              return (
                <div
                  key={interval.startTime.valueOf()}
                  onClick={() => {
                    showPeriod(interval.startTime, interval.endTime);
                    if (onYearClick) {
                      onYearClick();
                    }
                  }}
                  {...intervalProps}
                  className={intervalProps.className}
                >
                  <div className="sticky roboto timeline-header-interval timeline-year-interval">
                    {interval.startTime.format('YYYY')}
                  </div>
                </div>
              );
            })}
          </div>
        );
      }}
    </CustomHeader>
  );
};

export default TimelineYearHeader;
